import type { FaireProductEntity } from "../../entity_types/product";

export const p_xvrcrv8rrx: FaireProductEntity = {
  token: "p_xvrcrv8rrx",
  type: "product",
  name: "Grazie Thank You Card",
  brandToken: "b_btb379emrh",
  brandName: "Mel Andrel",
  imageUrl: "https://cdn.faire.com/fastly/998f16c8240b679bd700a48657ccbbdc184bc6d9ac2547718f88ea3c148ef667.png",
  galleryImageUrls: [],
  priceDollars: 2.75,
  description: "A simple, thoughtful greeting card to say thank you!\n\nGood to know: \n\n * Blank on the inside \n * A2 (4.25 inches by 5.5 inches) \n * Includes colored envelope \n * Individually wrapped in a cellophane sleeve or plastic free with card clasp. ",
  tags: [],
  msrpDollars: 5.5,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-09-06T18:34:02.969Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
